import logger from './logger';
import { LoggerTags } from './constants/loggerTags';

/**
 * Log an API error
 *
 * @param {Error} error - The error to log.
 * @param {string} [placement] - Optional identifier for the place where the error occurred; used for logging.
 * Specify a [set][of][braces] leading to the file/page where the error has occurred.
 */
const logApiError = (error: Error, placement?: string) => {
  logger.message(LoggerTags.API_ERROR, error.name, {
    ...(placement ? { placement } : {}),
    message: error.message,
    traceback: error.stack,
  });
};

export default logApiError;
